<tr #row>
    <ng-content>

    </ng-content>
</tr>
